<template>
	<md-dialog :md-active="show" :md-close-on-esc="false" :md-click-outside-to-close="false" class="mybody">
		<!-- Header -->
		<div class="dialog-header">
			<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
				{{ $t("data") | capitalize }} {{ $t($route.params.folder_id ? "procedure-tag" : "project-tag") }}
			</span>
			<div style="margin-left: auto; margin-right: 0">
				<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
					<md-icon style="color: white">close</md-icon>
				</md-button>
			</div>
		</div>

		<!-- Body -->
		<div class="dialog-body">
			<p>{{ $t("project-data-list-info") }}.</p>
			<div v-for="(variable, index) in variables" :key="variable.node.id">
				<el-row
					v-if="index === 0 || variables[index - 1].node.level !== variable.node.level"
					type="flex"
					align="middle"
				>
					<h4>
						{{ $t("data") | capitalize }}
						{{ levelTexts[variable.node.level] ? $t(levelTexts[variable.node.level].name) : "" }}
					</h4>
					<el-tooltip
						:content="levelTexts[variable.node.level] ? $t(levelTexts[variable.node.level].help) : ''"
						placement="top"
					>
						<md-icon>help</md-icon>
					</el-tooltip>
				</el-row>

				<variable-input
					:ref="variable.node_value.id"
					:variable="variable"
					@setField="setValue"
					@handleImage="setImage"
					style="background-color: #eeeeee"
				></variable-input>
			</div>
		</div>

		<!-- Footer -->
		<div class="dialog-footer">
			<div style="margin-left: auto; margin-right: 0">
				<md-button class="cancel" @click="$emit('close')">
					{{ $t("cancel") }}
				</md-button>
				<md-button class="add" @click="saveCustomFieldValues" :disabled="false">
					<i class="el-icon-loading" v-if="loading" />
					<span>{{ $t("save") }}</span>
				</md-button>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"
import { filters } from "@/utils/utils"
import VariableInput from "@/modules/documents/components/variable-input"

export default {
	name: "project-variables",
	mixins: [filters],
	components: {
		VariableInput
	},
	props: {
		show: {
			type: Boolean,
			required: true
		}
	},
	data: () => ({
		rawVariables: [],
		loading: false,
		levelTexts: {
			1: { name: "project-tag", help: "project-data-help" },
			2: { name: "procedure-tag", help: "procedure-data-help" }
		}
	}),
	computed: {
		variables() {
			return this.rawVariables !== []
				? this.rawVariables
						.map(variable => ({
							node: {
								...variable.custom_field,
								custom_field_value: variable,
								rules: JSON.parse((variable.custom_field )? variable.custom_field.rules || "{}" : "{}")
							},
							node_value: variable ? variable : undefined
						}))
						.sort(
							({ node: nodeA }, { node: nodeB }) =>
								nodeA.level - nodeB.level || new Date(nodeA.created_at) - new Date(nodeB.created_at)
						)
				: []
		}
	},
	watch: {
		"$route.params.folder_id"(newValue) {
			if (newValue || this.$route.params.project_id) this.getVariables()
		},
		"$route.params.project_id"() {
			this.getVariables()
		}
	},
	created() {
		this.getVariables()
	},
	methods: {
		async getVariables() {
			this.loading = true

			this.rawVariables = []

			await axios(
				`${process.env.VUE_APP_API_URL}/api/customfieldvalues/getByProject/${this.$route.params.project_id}`,
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				}
			)
				.then(({ data }) => {
					const variables = this.$route.params.folder_id
						? data.filter(({ custom_field: customField }) => customField.level === 1)
						: data
					this.rawVariables.push(...variables)
				})
				.catch(() => {})

			if (this.$route.params.folder_id)
				await axios(
					`${process.env.VUE_APP_API_URL}/api/customfieldvalues/getByProject/${this.$route.params.folder_id}`,
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
					.then(({ data }) => this.rawVariables.push(...data))
					.catch(() => {})

			this.loading = false
		},
		setValue(variable, value) {
			let rawVariable = this.rawVariables.find(({ id }) => id === variable.node_value.id)
			if (rawVariable) rawVariable.value = value
		},
		setImage(customFieldId, imageFile) {
			let rawVariable = this.rawVariables.find(({ id }) => id === customFieldId)
			if (rawVariable) rawVariable.value = imageFile
		},
		saveCustomFieldValues() {
			const variables = this.rawVariables
				.filter(({ type }) => type !== "image")
				.map(variable => ({
					...variable,
					value: String(this.$refs[variable.id][0].value)
				}))
			const formDataImages = this.rawVariables
				.filter(({ type }) => type === "image")
				.map(variable => {
					let formDataImage = new FormData()
					formDataImage.append("id", variable.id)
					formDataImage.append("value", variable.value)
					formDataImage.append("custom_field_id", variable.id)
					formDataImage.append("owner_type", variable.level)
					formDataImage.append("owner_id", variable.level)
					return formDataImage
				})

			let apiCalls = []

			apiCalls.push(
				axios.post(
					`${process.env.VUE_APP_API_URL}/api/customfieldvalues/addOrUpdate`,
					{ variables },
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
			)

			formDataImages.forEach(form =>
				apiCalls.push(
					axios.post(`${process.env.VUE_APP_API_URL}/api/customfieldvalues/addOrUpdateImage`, form, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					})
				)
			)

			axios
				.all(apiCalls)
				.then(() => this.$notification("success", this.$t("save-successful"), "", 4500))
				.catch(() => this.$notification("error", this.$t("save-error"), "", 0))
		}
	}
}
</script>
